import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaImage from './VaImage.vue'

export default withConfigTransport(VaImage)
